import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postLocation } from '../Api'

export default generateApiAction({
  baseType: Types.LOCATIONS.POST,
  api: postLocation,
  responseType: RESPONSETYPE.IDS
})



// WEBPACK FOOTER //
// ./src/actions/locations/PostAction.js